var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaCampaignChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66667L7.33333 9.33333L6 8M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z",
    stroke: "url(#paint0_linear_6441_50785)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6441_50785",
    x1: 0.0408164,
    y1: -0.750001,
    x2: 17.2519,
    y2: 1.27803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432884,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaCampaignChecked);
export default __webpack_public_path__ + "static/media/instaCampaignChecked.fb68c15bd72eac39cdd2a4eebeda5720.svg";
export { ForwardRef as ReactComponent };